import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Matiere } from 'src/model/model.matiere';
import { tap, catchError } from 'rxjs/operators';
import { Page } from 'src/model/model.page';

@Injectable({
    providedIn: 'root'
})
export class MatiereService {
    basePath = environment.BasePath + "/survey"; // e.g., http://localhost:8080/survey

    constructor(private httpClient: HttpClient) { }

    private getHeaders(): HttpHeaders {
        const token = sessionStorage.getItem('token') || '';
        const etabData = sessionStorage.getItem('etablissement');
        let idEtab = '0';

        if (etabData) {
            try {
                const parsedData = JSON.parse(etabData);
                idEtab = parsedData?.id?.toString() || '0'; // Use 'id' from session storage
            } catch (e) {
                console.error('Error parsing etablissement from sessionStorage:', e);
            }
        } else {
            console.warn('No etablissement data in sessionStorage, using default idEtab:', idEtab);
        }

        return new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'idEtab': idEtab
        });
    }

    getMatieres(name: string, description: string, cout: string, page: number, size: number): Observable<Page<Matiere>> {
        const url = `${this.basePath}/chercheMatiere?name=${name || ''}&description=${description || ''}&cout=${cout || ''}&page=${page}&size=${size}`;
        return this.httpClient.get<Page<Matiere>>(url, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from getMatieres:', response)),
                catchError(error => {
                    console.error('Error in getMatieres:', error);
                    throw error;
                })
            );
    }

    getAllMatieres(): Observable<Matiere[]> {
        const url = `${this.basePath}/matiere`;
        return this.httpClient.get<Matiere[]>(url, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from getAllMatieres:', response)),
                catchError(error => {
                    console.error('Error in getAllMatieres:', error);
                    throw error;
                })
            );
    }

    getMatieresById(id: number): Observable<Matiere> {
        const url = `${this.basePath}/matiere/${id}`;
        return this.httpClient.get<Matiere>(url, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from getMatieresById:', response)),
                catchError(error => {
                    console.error('Error in getMatieresById:', error);
                    throw error;
                })
            );
    }

    saveMatieres(matiere: Matiere): Observable<Matiere> {
        const url = `${this.basePath}/matiere`;
        return this.httpClient.post<Matiere>(url, matiere, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from saveMatieres:', response)),
                catchError(error => {
                    console.error('Error in saveMatieres:', error);
                    throw error;
                })
            );
    }

    editMatiere(matiere: Matiere): Observable<Matiere> {
        const url = `${this.basePath}/matiere/${matiere.id}`;
        return this.httpClient.put<Matiere>(url, matiere, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from editMatiere:', response)),
                catchError(error => {
                    console.error('Error in editMatiere:', error);
                    throw error;
                })
            );
    }

    deleteMatiere(id: number): Observable<void> {
        const url = `${this.basePath}/matiere/${id}`;
        return this.httpClient.delete<void>(url, { headers: this.getHeaders() })
            .pipe(
                tap(response => console.log('Response from deleteMatiere:', response)),
                catchError(error => {
                    console.error('Error in deleteMatiere:', error);
                    throw error;
                })
            );
    }
}